import { Button } from '@acast-tech/decibel';

/** Generic error fallback used by Sentry error boundaries. */
const ErrorFallback = () => (
  <div className="flex flex-col items-center justify-center gap-4 p-8">
    <p className="text-center text-neutral-700">Something went wrong.</p>
    <Button variant="primary" onClick={() => window.location.reload()}>
      Reload page
    </Button>
  </div>
);

export default ErrorFallback;
